import { DataServiceService } from './../../../services/data-service.service';
import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/services/product.service';
import { ProductModel } from 'src/app/model/selfcareproducts';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-homedataplans',
  templateUrl: './homedataplans.component.html',
  styleUrls: ['./homedataplans.component.css']
})
export class HomedataplansComponent implements OnInit {
  errorMessage:string; 
  homedataplans : ProductModel[];
  OurOffers : ProductModel[];
  aProduct: ProductModel;


  constructor(private productservise:ProductService , private router: Router,
    private authenticationService: AuthenticationService, private dataServiceService: DataServiceService) 
  { 

    this. loadSelfcareproducts();

   // this.homedataplans = JSON.parse(localStorage.getItem('homedataplans'));
/*
    if(! this.homedataplans)
    {

     this. loadSelfcareproducts();
    }*/
 

  }

  ngOnInit() {
  }
buyProductNow(productModel: ProductModel)
{
  this.aProduct = productModel;
// check if user is logged in

if (this.authenticationService.isLoggedIn()) 
{ 
  this.dataServiceService.changeProduct(productModel);
   this.router.navigate(['/cartcheckout']);
  
 }  
else{   // take user to product checkout

  this.router.navigate(['/checkout']);

}

}
loadSelfcareproducts()
{


  this.productservise.getSelfcareProducts().subscribe(    
    data => {    
      //    
      if(data.Status=="1")    
      {       
        
             //
         
     
      var products :  ProductModel[]= <ProductModel[]> data.Result;                 
      var displayProducts = products.filter(product => product.Display.ShowonSelfcare === true);
      
      displayProducts.forEach(x1 => x1.DisplayName = "₦" + x1.Price.toLocaleString() + " - " + x1.Name);

       var OurOffers = products.filter(product => product.Display.CanRenew === false);


       this.homedataplans  = products.filter(product => product.Display.CanRenew === true);
   
       localStorage.setItem("displayProducts",JSON.stringify(displayProducts));
       localStorage.setItem("OurOffers",JSON.stringify(this.OurOffers));
 
       localStorage.setItem("homedataplans",JSON.stringify(this.homedataplans));
       
      }    
      else{   
     
        
        //    
        this.errorMessage = data.Message;    
      //  this.alertService.error(this.errorMessage);
      }    
    },     
    error => {    
       
    

      //his.errorMessage = error.message; 
      
     // this.alertService.error(this.errorMessage); 
    });   


}


  
}
